import qs from 'qs'
import axios from '../index'
/**
 * @description 获取预售商品
 * @author cc
 * @date 2019-09-10
 * @export
 */
export function loadPresellGoods (params) {
  return axios.post('/presell/load-presell-goods', qs.stringify(params))
}
/**
 * @description 加载预售订单列表
 * @author cc
 * @date 2019-09-20
 * @export
 */
export function loadPresellOrderList (params) {
  return axios.post('/order/load-presell-order-list', qs.stringify(params))
}
/**
 * @description 预售订单详情
 * @author cc
 * @date 2019-09-21
 * @export
 */
export function presellOrderDetail (params) {
  return axios.post('/order/presell-order-detail', qs.stringify(params))
}
/**
 * @description 取消预售单
 * @author cc
 * @date 2019-09-21
 * @export
 */
export function chgPresellOrderState (params) {
  return axios.post('/order/chg-presell-order-state', qs.stringify(params))
}
/**
 * @description 预售提醒
 * @author cc
 * @date 2019-09-26
 * @export
 */
export function presellSms (params) {
  return axios.post('/presell/presell-sms', qs.stringify(params))
}
/**
 * @description 区域经销电话号码返回
 * @author cc
 * @date 2019-09-26
 * @export
 */
export function controlGoodsApplyTips (params) {
  return axios.post('/ctrlmarketing/control-goods-apply-tips', qs.stringify(params))
}
/**
 * @description 确定收货
 * @author cc
 * @date 2019-10-9
 * @export
 */
export function orderOk (params) {
  return axios.post('/order/orderok/', qs.stringify(params))
}
